/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValueResponseDto
 */
export interface MetricValueResponseDto {
    /**
     * ID
     * @type {number}
     * @memberof MetricValueResponseDto
     */
    id?: number;
    /**
     * Patient ID
     * @type {string}
     * @memberof MetricValueResponseDto
     */
    patientId: string;
    /**
     * Health provider ID
     * @type {number}
     * @memberof MetricValueResponseDto
     */
    healthProviderId: number;
    /**
     * Metric ID
     * @type {number}
     * @memberof MetricValueResponseDto
     */
    metricId: number;
    /**
     * Integer value for the metric
     * @type {number}
     * @memberof MetricValueResponseDto
     */
    valueInt?: number;
    /**
     * Float value for the metric
     * @type {number}
     * @memberof MetricValueResponseDto
     */
    valueFloat?: number;
    /**
     * Text value for the metric. For well-being scores, this contains the optional note.
     * @type {string}
     * @memberof MetricValueResponseDto
     */
    valueText?: string;
    /**
     * Multi-dimensional values as JSON
     * @type {object}
     * @memberof MetricValueResponseDto
     */
    multiDimValues?: object;
    /**
     * Start date and time of the measurement
     * @type {Date}
     * @memberof MetricValueResponseDto
     */
    startDate: Date;
    /**
     * End date and time of the measurement
     * @type {Date}
     * @memberof MetricValueResponseDto
     */
    endDate: Date;
    /**
     * Created date and time of the measurement
     * @type {Date}
     * @memberof MetricValueResponseDto
     */
    createdAt: Date;
    /**
     * Updated date and time of the measurement
     * @type {Date}
     * @memberof MetricValueResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the MetricValueResponseDto interface.
 */
export function instanceOfMetricValueResponseDto(value: object): value is MetricValueResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('healthProviderId' in value) || value['healthProviderId'] === undefined) return false;
    if (!('metricId' in value) || value['metricId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MetricValueResponseDtoFromJSON(json: any): MetricValueResponseDto {
    return MetricValueResponseDtoFromJSONTyped(json, false);
}

export function MetricValueResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'patientId': json['patientId'],
        'healthProviderId': json['healthProviderId'],
        'metricId': json['metricId'],
        'valueInt': json['valueInt'] == null ? undefined : json['valueInt'],
        'valueFloat': json['valueFloat'] == null ? undefined : json['valueFloat'],
        'valueText': json['valueText'] == null ? undefined : json['valueText'],
        'multiDimValues': json['multiDimValues'] == null ? undefined : json['multiDimValues'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function MetricValueResponseDtoToJSON(json: any): MetricValueResponseDto {
    return MetricValueResponseDtoToJSONTyped(json, false);
}

export function MetricValueResponseDtoToJSONTyped(value?: MetricValueResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'healthProviderId': value['healthProviderId'],
        'metricId': value['metricId'],
        'valueInt': value['valueInt'],
        'valueFloat': value['valueFloat'],
        'valueText': value['valueText'],
        'multiDimValues': value['multiDimValues'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

